<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vs-table
        ref="table"
        :max-items="20"
        pagination
        search
        :data="locations"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
              class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
              @click="addLocation"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
            <span class="ml-2 text-base text-primary disabled" >Bezorglocatie toevoege</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">

          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Locatie</vs-th>
        <vs-th sort-key="fees">Bezorgkosten</vs-th>
        <vs-th sort-key="minimum">Minimum</vs-th>
        <vs-th sort-key="actions">Acties</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
        >
          <vs-td>
            <p class="location-name">{{ tr.label }}</p>
          </vs-td>
          <vs-td>
            <p class="location-fee">{{ tr.fee }}</p>

          </vs-td>

          <vs-td>
            <p class="permission-name">{{ tr.minimum }}</p>
          </vs-td>
          <vs-td>
            <p class="deliverer-phone_number">
              <vs-button
                  color="danger"
                  type="flat"
                  ref="loadableButton"
                  icon-pack="feather"
                  icon="icon-trash-2"
              ></vs-button>
            </p>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <ht-create-location-popup></ht-create-location-popup>
  </div>
</template>

<script>

import CreateLocationPopup from '../Locations/CreateLocationPopup';


export default {


  components: {
    "ht-create-location-popup": CreateLocationPopup
  },
  data() {
    return {
      locations: []
    };
  },
  methods: {
    getDeliveryLocations() {
      this.$http.get('v1/delivery-locations', {
        headers: {
          Authorization: "Bearer " + this.$auth.token
        },
      }).then(response => {
        this.locations = response.data.locations;
      }).catch(error => {
        this.$util.logError(error, this.$vs);
      });
    },

    addLocation() {
      console.log('test');
    },

  },
  mounted() {

  }
};
</script>